import { render, staticRenderFns } from "./QuotationCommonList.vue?vue&type=template&id=460855a1&scoped=true&"
import script from "./QuotationCommonList.vue?vue&type=script&lang=js&"
export * from "./QuotationCommonList.vue?vue&type=script&lang=js&"
import style0 from "./QuotationCommonList.vue?vue&type=style&index=0&id=460855a1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460855a1",
  null
  
)

export default component.exports